import { Button } from "@mui/material";
import { BaseDropdown, BaseInput } from "components/core";
import { FieldArray } from "formik";
import React, { useMemo, useState } from "react";
import "./styles.css";
import GradeAccordion from "./GradeAccordion";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { Ptag } from "components/core/fonts";

const GradeDiseaseWise = ({ formikProps, attribute, toggleHandler }) => {
  const initalToggleStatus = useMemo(() => {
    let status = false;
    if (!attribute?.toggle) {
      status = true;
    }
    if (formikProps.values?.disease_wise_limit_detail?.[0]?.disease_name) {
      status = true;
    }
    return status;
  }, [formikProps, attribute]);

  const [toggleStatus, setToggleStatus] = useState(initalToggleStatus);
  const diseaseOptions = useMemo(() => {
    const options = attribute?.disease_names_selectables.map(
      ({ display_name, value }) => ({
        label: display_name,
        value,
      })
    );

    return options;
  }, [attribute]);

  // Function to get filtered dropdown options for each disease dropdown
  const getFilteredDiseaseOptions = (currentIndex) => {
    const allOptions = diseaseOptions || [];
    const currentValues = formikProps.values?.disease_wise_limit_detail || [];

    // Filter out diseases that are already selected in other dropdowns
    const filteredOptions = allOptions.filter((option) => {
      return !currentValues.some((disease, index) => {
        // Ignore the current dropdown index
        if (index === currentIndex) return false;
        // Check if this disease is already selected in another dropdown
        return disease.disease_name === option.value;
      });
    });

    return filteredOptions;
  };

  const interstitialToggler = (bool) => {
    setToggleStatus(bool);
    toggleHandler &&
      toggleHandler(bool, attribute?.attribute_data?.attribute_name);
  };

  const doesValueExist = useMemo(() => {
    const values = formikProps.values;
    if (!values?.disease_wise_limit_detail?.[0]?.disease_name) return false;
    return true;
  }, [formikProps]);

  return (
    <GradeAccordion
      title="Disease Wise Sub-limit"
      showSwitch={attribute?.toggle}
      canSelect={toggleStatus}
      setToggleStatus={interstitialToggler}
      expanded={doesValueExist || toggleStatus}
    >
      <FieldArray name="disease_wise_limit_detail">
        {({ push, remove }) => (
          <>
            <section
              style={{
                marginBottom: "2rem",
              }}
            >
              {/* General error display for no diseases added */}

              {formikProps.values.disease_wise_limit_detail.map(
                (item, index) => {
                  return (
                    <>
                      <section>
                        <div style={{ marginBottom: "2rem" }}>
                          <BaseDropdown
                            staticLabel="Disease Name"
                            fontSize="16px"
                            options={getFilteredDiseaseOptions(index)}
                            disabled={!toggleStatus}
                            formikProps={{
                              ...formikProps,
                              name: `disease_wise_limit_detail[${index}]disease_name`,
                            }}
                          />
                          {/* Error display for Disease Name */}
                         
                          <div className="disease-wise-container">
                            <BaseInput
                              customValue={`disease_wise_limit_detail[${index}]['disease_limit']`}
                              staticLabel="Limit"
                              fontSize="16px !important"
                              disabled={!toggleStatus}  
                              formikProps={{
                                ...formikProps,
                                name: `disease_wise_limit_detail[${index}]disease_limit`,
                              }}
                            />
                            {/* Error display for Disease Limit */}
                           

                            <BaseInput
                              customValue={`disease_wise_limit_detail[${index}]['remarks']`}
                              staticLabel="Remarks (optional)"
                              fontSize="16px !important"
                              disabled={!toggleStatus}
                              formikProps={{
                                ...formikProps,
                                name: `disease_wise_limit_detail[${index}]remarks`,
                              }}
                            />
                          </div>
                        </div>
                        {(
                          <Button
                            sx={{
                              marginTop: "-10px",
                              fontSize: "14px",
                              textDecoration: "underline",
                              textTransform: "capitalize",
                              color: "red",
                            }}
                            startIcon={<RemoveCircleOutlineIcon />}
                            onClick={() => remove(index)}
                          >
                            <Ptag style={{color: "red", fontSize:"14px"}}>
                              Remove Disease 
                            </Ptag>

                          </Button>
                        )}
                        {index <
                          formikProps.values.disease_wise_limit_detail.length -
                          1 && (
                            <>
                              <div
                                style={{
                                  borderTop: `1px dashed #989898`,
                                  marginTop: "3rem",
                                  marginBottom: "2.6rem",
                                }}
                              />
                            </>
                          )}
                      </section>
                    </>
                  );
                }
              )}
            </section>
            {toggleStatus && (
              <footer
                style={{
                  display: "flex",
                }}
              >
                <Button
                  sx={{
                    fontSize: "14px !important",
                    textDecoration: "underline",
                    textTransform: "capitalize",
                    fontFamily:'Inter',
                  }}
                  startIcon={<ControlPointIcon />}
                  onClick={push}
                >
                  Add Another Disease
                </Button>
              </footer>
            )}
          </>
        )}
      </FieldArray>
    </GradeAccordion>
  );
};

export default GradeDiseaseWise;
